import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKey, faSync } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from 'styled-components';
import { ReactComponent as User } from '../../assets/user.svg';
import { ReactComponent as Poligono } from '../../assets/Poligono.svg';
import { CustomModal } from '../CustomModal';
import MudarSenha from '../Login/MudarSenha';
import BotaoLogout from './BotaoLogout';
export default function BotaoUser({ loadingTrocarSenha, trocarSenhaStatus, handleRecalcularParam, handleSubmitTrocarSenhaParam, handleStatusOKTrocarSenha, handleLogout }) {
    const theme = useTheme();
    // geral
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleAtualizaFlag = () => {
        setTimeout(() => {
            localStorage.setItem('flagTrocaSenha', '');
            window.location.reload();
        }, 1200);
    };
    // botão de recalcular
    const handleRecalcular = () => {
        handleClose();
        handleRecalcularParam();
    };
    const handleSubmitTrocarSenha = (event) => {
        event.preventDefault();
        setError(false);
        handleStatusOKTrocarSenha();
        const formData = new FormData(event.target);
        const password = formData.get('novaSenha');
        const password2 = formData.get('confirmeNovaSenha');
        if (password !== password2 || !password)
            setError(true);
        else {
            localStorage.setItem('senhaLogin', password2);
            handleSubmitTrocarSenhaParam(password);
        }
    };
    // botão de trocar senha
    const [openModal, setOpenModal] = useState(false);
    const [openModalAviso, setOpenModalAviso] = useState(false);
    const [aviso, setAviso] = useState('');
    const [error, setError] = useState(false);
    const handleOpenTrocarSenha = () => {
        setOpenModal(true);
        setError(false);
        handleClose();
    };
    useEffect(() => {
        if (trocarSenhaStatus === 'ok') {
            setAviso('Senha trocada com sucesso!');
            setOpenModal(false);
            setOpenModalAviso(true);
            handleAtualizaFlag();
            handleStatusOKTrocarSenha();
        }
    }, [trocarSenhaStatus]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { children: [_jsxs(Button, Object.assign({ id: "basic-button", "aria-controls": open ? 'basic-menu' : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, onClick: handleClick }, { children: [_jsx(User, { style: { marginLeft: 32 }, fill: theme.menuIconsColor }), _jsx(Poligono, { style: { marginLeft: 6 }, fill: theme.menuIconsColor })] })), _jsxs(Menu, Object.assign({ id: "basic-menu", anchorEl: anchorEl, open: open, onClose: handleClose, MenuListProps: {
                            'aria-labelledby': 'basic-button',
                        } }, { children: [_jsx(BotaoLogout, { handleLogout: handleLogout }), _jsxs(MenuItem, Object.assign({ onClick: handleRecalcular }, { children: [_jsx(FontAwesomeIcon, { icon: faSync, style: { marginRight: 8 } }), "Recalcular"] })), _jsxs(MenuItem, Object.assign({ onClick: handleOpenTrocarSenha }, { children: [_jsx(FontAwesomeIcon, { icon: faKey, style: { marginRight: 8 } }), "Mudar senha"] }))] }))] }), _jsx(CustomModal, Object.assign({ open: openModal, onCloseHandle: () => setOpenModal(false), minWidth: 300, maxWidth: 500 }, { children: _jsx(MudarSenha, { loading: loadingTrocarSenha, error: error, handleSubmit: handleSubmitTrocarSenha, status: trocarSenhaStatus, handleLogout: handleLogout }) })), _jsx(CustomModal, Object.assign({ open: openModalAviso, onCloseHandle: () => setOpenModalAviso(false), minWidth: 300, maxWidth: 500 }, { children: aviso }))] }));
}
export { default as BotaoLogout } from './BotaoLogout';
